import { FlowsLayout } from 'components/flows/common/FlowsLayout/FlowsLayout';
import { Content } from 'components/flows/propertyInsurance/PurchasePage/Content';
import { useTranslation } from 'react-i18next';

export const PropertyInsurancePurchasePage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FlowsLayout fullWidth={true} navigationText={t('flows.header.navigation.propertyInsurance')}>
      <Content />
    </FlowsLayout>
  );
};
